import React, { Fragment, useState } from "react";
import { Form, Row, Col, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../../../Components/Navbar/Navbar";
import "../Inventory.css";
import {
  createItemDetails,
  getInventoryDetails,
} from "../../../Helpers/apiCalls/Inventory/ItemDetailsApi";
import { refreshPage, toastStyle } from "../../../Helpers/Utils/Common";
import toast from "react-hot-toast";
import Footer from "../../../Components/Footer/Footer";

/**
 *  COMPONENT: FORM TO ADD OR EDIT PAYMENT
 */
function ItemDetails() {
  const [inactive, setInactive] = useState(true);
  const { id, type } = useParams();
  let navigate = useNavigate();

  const [itemName, setItemName] = useState("");
  const [unit, setUnit] = useState("");
  const [itemDetails, setItemDetails] = useState([]);

  function renderTable() {
    return (
      <Table>
        <thead>
          <tr>
            <th>Branch</th>
            <th>Default Unit</th>
            <th>Min Level</th>
            <th>Max Level</th>
            <th>Critical Level</th>
            <th>Current Level</th>
            <th>Acceptable Variance</th>
            <th>Beginning Inventory</th>
          </tr>
        </thead>
        <tbody>
          {itemDetails.map((branch, index) => {
            return (
              <tr>
                <td>
                  {branch.name ? branch.name : branch.inventory_group_name}
                </td>
                <td>{unit}</td>
                <td>
                  <Form.Control
                    type="number"
                    name="min"
                    className="ps-label-content"
                    defaultValue={branch.min ? branch.min : 0}
                    onBlur={(e) => handleUserInput(e, index, branch)}
                  />
                </td>
                <td>
                  <Form.Control
                    type="number"
                    name="max"
                    className="ps-label-content"
                    defaultValue={branch.max ? branch.max : 0}
                    onBlur={(e) => handleUserInput(e, index, branch)}
                  />
                </td>
                <td>
                  <Form.Control
                    type="number"
                    name="critical_level"
                    className="ps-label-content"
                    defaultValue={
                      branch.critical_level ? branch.critical_level : 0
                    }
                    onBlur={(e) => handleUserInput(e, index, branch)}
                  />
                </td>
                <td>{branch.current_qty ? branch.current_qty : 0}</td>
                <td>
                  <Form.Control
                    type="number"
                    name="acceptable_variance"
                    className="ps-label-content"
                    defaultValue={
                      branch.acceptable_variance
                        ? branch.acceptable_variance
                        : 0
                    }
                    onBlur={(e) => handleUserInput(e, index, branch)}
                  />
                </td>
                {branch.type === "warehouse" && (
                  <>
                    <td>{branch.beginning_qty ? branch.beginning_qty : 0}</td>
                  </>
                )}
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }

  async function fetchDetails(item_id) {
    setItemDetails([])
    const response = await getInventoryDetails(item_id);
    if (response.data) {
      var warehouse = response.data.data.warehouse_inventories;
      warehouse.map((house, index) => {
        var info = house;
        info.type = "warehouse";
        setItemDetails((prev) => [...prev, info]);
        return info;
      });

      var inventories = response.data.data.inventory_group_details;
      inventories.map((inventory, index) => {
        var info = inventory;
        info.type = "inventory";
        setItemDetails((prev) => [...prev, info]);
        return info;
      });
      setItemName(response.data.data.item_name);
      setUnit(response.data.data.item_unit);
    }
  }

  async function saveDetails() {
    const response = await createItemDetails(
      id,
      itemDetails[0].item_unit_id,
      itemDetails
    );
    if (response.data) {
      toast.success(response.data.message, { style: toastStyle() });
      setTimeout(() => {
        navigate("/itemlists");
      }, 1000);
    } else {
      response.error?.response?.data?.messages.map((data) => {
        return toast.error(data);
      })
      setTimeout(() => {
        refreshPage();
      }, 1000);
    }
  }

  function handleUserInput(e, index, branch) {
    var temp = itemDetails;
    const { name, value } = e.target;
    temp[index][name] = value;
    setItemDetails(temp);
  }

  React.useEffect(() => {
    fetchDetails(id);
  }, []);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"WH INVENTORY"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={8}>
              <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> ITEM DETAILS </h1>
          </Col>
        </Row>

        {/* FORM */}

        <div className="edit-form ps-form">
          <Fragment>
              <Row>
                <h3 className="page-subtitle fs-5">
                  <strong>{itemName}</strong>
                </h3>
              </Row>
              <Row>
                <Col>
                <div className="edit-purchased-items mt-4">
                  {itemDetails.length === 0 ? (
                    <span>No Branch Found!</span>
                  ) : (
                    renderTable()
                  )}
                </div>
                </Col>
              </Row>
          </Fragment>

          <div className="d-flex justify-content-end pt-5 pb-3">
            <button
              type="button"
              className="button-secondary me-3"
              onClick={() => navigate(-1)}
            >
              Close
            </button>
            <button
              type="button"
              className="button-primary"
              onClick={() => saveDetails()}
            >
              Save
            </button>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  );
}

export default ItemDetails;
